import React, { useContext, useState, useEffect } from 'react';

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import DashboardFilters from './DashboardFilters'

import { DateTime } from 'luxon';

import styles from '../../services/styles';
import api from '../../services/api';
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import moment from 'moment';
import { displayMessage } from '../../services/helper';

import EvoMonitoryChart from '../dentist_dashboard/EvoMonitoryChart'
import EvoExerciseChart from '../dentist_dashboard/EvoExerciseChart'
import GroupingLevelChart from '../dentist_dashboard/GroupingLevelChart'
import PatientScoreChart from '../dentist_dashboard/PatientScoreChart'
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';


Chart.register(CategoryScale)

const { tc1 } = styles


export default function Dashboard() {


    const lastMoonday = DateTime.now().minus({ weeks: 1 }).startOf("week").toJSDate()
    const nextFriday = DateTime.now().minus({ weeks: 1 }).endOf("week").minus({ days: 2 }).toJSDate()
    const [evoMonitoryChart, setEvoMonitoryChart] = useState(null)
    const [evoExerciseChart, setEvoExerciseChart] = useState(null)
    const [evoGroupingChart, setEvoGroupingChart] = useState(null)
    const [groupingLevelChart, setGroupingLevelChart] = useState(null)
    const [patientScoreChart, setPatientScoreChart] = useState(null)
    const dates = {
        start_date: moment(lastMoonday).format('YYYY-MM-DD'),
        end_date: moment(nextFriday).format('YYYY-MM-DD'),
    }
    const {
        mobile_mode,
        setShowLoading,
        user
    } = useContext(GeneralContext)

    useEffect(() => {
        // loadAllData();
        //sempre que abria a tela estava sobrecarregando o servidor
    }, [])

    const loadAllData = async () => {
        setShowLoading(true);
        await loadEvoMonitoryChart(dates)
        await loadEvoExerciseChart(dates)
        // await loadEvoGroupingChart(dates)
        await loadGroupingLevelChart(dates)
        await loadPatientScoreChart(dates)
        setShowLoading(false);
    }

    const loadEvoMonitoryChart = async (currentFilters) => {
        try {
            if (!currentFilters.start_date && !currentFilters.end_date) {
                loadEvoMonitoryChart(dates)
            }
            const payload = { ...currentFilters, dentist_id: user?.id }
            const { data } = await api.dashboards.findEvoMonitoryChart(payload)
            setEvoMonitoryChart(data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadEvoExerciseChart = async (currentFilters) => {
        try {
            if (!currentFilters.start_date && !currentFilters.end_date) {
                loadEvoExerciseChart(dates)
            }
            const payload = { ...currentFilters, dentist_id: user?.id }
            const { data } = await api.dashboards.findEvoExerciseChart(payload)
            setEvoExerciseChart(data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadEvoGroupingChart = async (currentFilters) => {
        try {
            if (!currentFilters.start_date && !currentFilters.end_date) {
                loadEvoGroupingChart(dates)
            }
            const payload = { ...currentFilters, dentist_id: user?.id }
            const { data } = await api.dashboards.findEvoGroupingChart(payload)
            setEvoGroupingChart(data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadGroupingLevelChart = async (currentFilters) => {
        try {
            if (!currentFilters.start_date && !currentFilters.end_date) {
                loadGroupingLevelChart(dates)
            }
            const payload = { ...currentFilters, dentist_id: user?.id }
            const { data } = await api.dashboards.findGroupingLevelChart(payload)
            setGroupingLevelChart(data)
        } catch (error) {
            console.log(error)
        }
    }

    const loadPatientScoreChart = async (currentFilters) => {
        try {
            if (!currentFilters.start_date && !currentFilters.end_date) {
                loadPatientScoreChart(dates)
            }
            const payload = { ...currentFilters, dentist_id: user?.id }
            const { data } = await api.dashboards.findPatientScoreChart(payload)
            setPatientScoreChart(data)
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <div style={{ color: tc1, fontWeight: 'bold', marginBottom: 15, fontSize: mobile_mode ? 11 : 24 }}>{displayMessage('DASHBOARD')}</div>

            <DashboardFilters
                loadEvoMonitoryChart={loadEvoMonitoryChart}
                loadEvoExerciseChart={loadEvoExerciseChart}
                // loadEvoGroupingChart={loadEvoGroupingChart}
                loadGroupingLevelChart={loadGroupingLevelChart}
                loadPatientScoreChart={loadPatientScoreChart}
                nextFriday={nextFriday}
                nextMonday={lastMoonday}

            />

            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', height: '100%', justifyContent: 'center' }}>
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage('AVERAGE_STARS')}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <EvoMonitoryChart evoMonitoryChart={evoMonitoryChart} />
                </div>
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage('AVERAGE_EXERCISE_STARS')}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <EvoExerciseChart evoExerciseChart={evoExerciseChart} />
                </div>
                {/* <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <EvoGroupingChart evoGroupingChart={evoGroupingChart} />
                </div> */}
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage('GROUPING_BY_LEVEL')}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <GroupingLevelChart groupingLevelChart={groupingLevelChart} />
                </div>
                <div style={{ display: 'flex', width: '95%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ marginLeft: 'auto', marginRight: 'auto', fontSize: 20, }}>
                        {displayMessage('PATIENT_BY_AVERAGE')}
                    </div>
                    <div>
                        <Tooltip
                            placement="left"
                            color={tc1}
                            title={displayMessage('SOON_EXPLANATIONS')}>
                            <span style={{ fontSize: '20px' }}><QuestionCircleOutlined style={{ color: '#1052B4' }} /></span>
                        </Tooltip>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    width: mobile_mode ? '100%' : '95%',
                    alignItems: 'center',
                }}>
                    <PatientScoreChart patientScoreChart={patientScoreChart} />
                </div>
            </div>
        </>
    )
}
